module.exports = "/_next/static/images/428ddcd07cd764ba2b5b2a358ccccdcd-Nubank_HickDuarte_59058 1_md.png";